import { goToCalculatorLink } from '@blocks/BlockInvestCalculator'
import { PledgeSummaryResponse } from '@http/api-models/PledgeSummaryResponse'
import { apiUrls } from '@http/api-urls'
import { httpService } from '@http/service'
import { InvestorPopupFormProvider } from '@providers/investor-popup-form'
import { PageLayout } from '@shared/components/page-layout'
import { getHeaderActionButton } from '@shared/components/top-menu/shared/header-action-button'
import { NextPageFC } from '@shared/models/next-fc'
import { composeProviders } from '@shared/pipes/compose-providers'
import { GetServerSideProps } from 'next'
import { InvestBusiness, InvestBusinessPageProps } from 'screens/invest-business'

import { getSavingsParams } from '../ssr-resolvers/savings-params'

const InvestBusinessPage: NextPageFC<InvestBusinessPageProps> = (props) => InvestBusiness(props)

InvestBusinessPage.layout = composeProviders(
			[
				[
					InvestorPopupFormProvider,
					{
						title: <>Узнайте больше о&nbsp;сбережениях</>,
						subtitle: <>Оставьте заявку, мы&nbsp;перезвоним и&nbsp;расскажем о&nbsp;сбережениях</>,
						buttonText: 'Жду звонка',
					},
				],
			],
			(ownProps: any) =>
				PageLayout({
					...ownProps,
					menuProps: {
						...ownProps?.menuProps,
						hideEndAdornment: true,
					},
				})
		),
InvestBusinessPage.headProps = {
	title: 'Сбережения с гарантией выплат',
	description:
		'Сбережения с гарантией регулярных выплат. Высокая доходность. Под надзором ЦБ РФ и СРО. Надёжно: сбережения направляются только в залоговые займы. Есть резервные фонды.',
	ogTitle: 'Сбережения с гарантией выплат',
	ogImageName: 'new-invest-og-img.jpg',
}

export const getServerSideProps: GetServerSideProps<InvestBusinessPageProps> = async () => {
	try {
		const [pledgeSummary, savingsParams] = await Promise.all([
			httpService.get<PledgeSummaryResponse>(apiUrls.getSummaries()),
			getSavingsParams(),
		])

		const result = {
			props: {
				pageSettings: {
					savings: { params: savingsParams },
					pledgeSummary: pledgeSummary,
				},
			},
		}
		return result
	} catch {
		return {
			props: {
				pageSettings: {},
			},
		}
	}
}

export default InvestBusinessPage
